import React, { useState } from "react";
import styles from "./index.module.css";
import AmwayDetails from "./AmwayDetails";
import Overrides from "./Overrides";
import Qualifications from "./Qualifications";
import QualificationDetailModal from "./QualificationDetailModal";
import { useEventQualifications } from "./Qualifications/useEventQualifications";

const ThePulse = ({ iboNumber }) => {
  const [activeTab, setActiveTab] = useState("amway-details");
  const [showDetails, setShowDetails] = useState(false);

  const {
    filters,
    filtersLoading,
    selectedFilters,
    onChangeFilter,
    reportData,
    reportLoading,
    isRefreshing,
    refetchReport,
  } = useEventQualifications(iboNumber);

  const renderTabContent = () => {
    switch (activeTab) {
      case "amway-details":
        return <AmwayDetails iboNumber={iboNumber} />;
      case "qualifications":
        return (
          <Qualifications
            filters={filters}
            filtersLoading={filtersLoading}
            selectedFilters={selectedFilters}
            onChangeFilter={onChangeFilter}
            data={reportData}
            reportLoading={reportLoading}
            isRefreshing={isRefreshing}
            onRefresh={refetchReport}
            onViewQualificationDetails={() => setShowDetails(true)}
          />
        );
      case "overrides":
      default:
        return <Overrides iboNumber={iboNumber} />;
    }
  };

  return (
    <div className={styles.outer}>
      <div className={styles.container}>
        <div className={styles.tabsBar}>
          <button
            type="button"
            className={`${styles.tabButton} ${
              activeTab === "amway-details" ? styles.activeTabButton : ""
            }`}
            onClick={() => setActiveTab("amway-details")}
          >
            Amway Details
          </button>

          <button
            type="button"
            className={`${styles.tabButton} ${
              activeTab === "qualifications" ? styles.activeTabButton : ""
            }`}
            onClick={() => setActiveTab("qualifications")}
          >
            Qualifications
          </button>

          <button
            type="button"
            className={`${styles.tabButton} ${
              activeTab === "overrides" ? styles.activeTabButton : ""
            }`}
            onClick={() => setActiveTab("overrides")}
          >
            Overrides
          </button>
        </div>

        <div className={styles.dividerWrapper}>
          <div className={styles.divider} />
        </div>

        <div className={styles.tabContent}>{renderTabContent()}</div>

        <QualificationDetailModal
          open={showDetails}
          title={
            reportData?.qualificationDetails?.title || "Qualification Details"
          }
          descriptionHtml={
            reportData?.qualificationDetails?.descriptionHtml || ""
          }
          noteHtml={reportData?.qualificationDetails?.noteHtml || ""}
          onClose={() => setShowDetails(false)}
        />
      </div>
    </div>
  );
};

export default ThePulse;
